import MuiLoadingButton from '@mui/lab/LoadingButton';
import type { LoadingButtonProps } from './ILoadingButton';
import { styles } from './styles';

const LoadingButton = ({ sx, children, ...rest }: LoadingButtonProps) => (
    <MuiLoadingButton
        sx={[styles.root, ...(Array.isArray(sx) ? sx : [sx])]}
        {...rest}
    >
        {children}
    </MuiLoadingButton>
);

export default LoadingButton;
